export enum PublicTransportType {
  bus = "bus",
  tram = "tram",
  metro = "metro",
}
